/**
 * Reset stage input fields error class once user has changed input field. Also manipulates data-gtm-event-label if [name="type"] is present
 */

const init = function() {
  const stageFormElements = document.getElementsByClassName('stage-form');
  const regnum = document.getElementById('nykyisen_auton_rekisterinumero');
  const departmentSelect = document.getElementById('osasto');
  const messageField = document.getElementById('viesti');

  const errorSpan = document.createElement('span');
  errorSpan.classList.add('small');
  errorSpan.innerHTML = 'Pakollinen';

  /**
   * Check if departmentSelect has a value 3 (huolto)
   * if true, add required attribute to regnum
   * if false, remove required attribute from regnum
   * if regnum is empty, add error class
   * @type {boolean}
   * @return {void}
   */
  const toggleRegnumFieldsClassesAndSpan = function() {
    if (departmentSelect.value === '3') {
      regnum.classList.add('stage-required');
      regnum.required = true;
      (regnum.value === '') ? regnum.classList.add('stage-error') : regnum.classList.remove('stage-error');

      if (!regnum.nextElementSibling) {
        regnum.parentNode.insertBefore(errorSpan, regnum.nextSibling);
      }
    } else {
      regnum.classList.remove('stage-required');
      regnum.classList.remove('stage-error');
      regnum.required = false;

      if (regnum.nextElementSibling) {
        regnum.nextElementSibling.remove();
      }
    }
  }

  /**
   * Change messageField placeholder text depending on departmentSelect value
   *
   * @param {string} value - value of departmentSelect
   */
  const changeMessagePlaceholder = function(value) {
    if (value === '3') {
      messageField.placeholder = 'Kerro lyhyesti, kysymyksesi koskien Škoda-alkuperäisiä varaosia tai merkkihuoltoa. Huomaathan, että varsinainen huollon tai renkaidenvaihdon ajanvaraus tapahtuu täältä https://varaahuolto.skoda.fi/huolto/?Dealers=50433';
    } else {
      messageField.placeholder = 'Kerro lyhyesti, kuinka voimme auttaa.';
    }
  }

  /**
   * Toggle department options visibility
   *
   * @param {string} locationId - Id of selected location
   */
  const toggleDeparmentOptionsVisibility = function(locationId = '') {
    const departmentOptions = departmentSelect.closest('.multiselect-container').querySelectorAll('.multiselect-option');
    const selectedDepartmentLocation = departmentSelect.querySelector(`option[value="${departmentSelect.value}"]`).dataset.location;

    if (selectedDepartmentLocation !== locationId) {
      departmentSelect.value = '';
    }

    departmentOptions.forEach((option, i) => {
      if (option.dataset.location === locationId) {
        option.style.display = 'block';
      } else if (option.dataset.location) {
        option.style.display = 'none';
        option.selected = false;
      }
    });

    window.multiselects.osasto.onSelectElementChange();
  }

  /*
  *  check if departmentSelect exitst in DOM
  *  if true, call toggleRegnumFieldsClassesAndSpan()
  */
  if (departmentSelect) {
    toggleRegnumFieldsClassesAndSpan();
    changeMessagePlaceholder();
    toggleDeparmentOptionsVisibility();
  }

  if(stageFormElements.length) {
    for (let i = 0; i < stageFormElements.length; i++) {
      stageFormElements[i].addEventListener('change', e => {

        //if departmentSelect changed, check if it has value 3 (huolto) and toggle required and classes for regnum
        if (e.target.name === 'toimipiste') {
          toggleDeparmentOptionsVisibility(e.target.value);
        }

        if (e.target.name === 'osasto') {
          toggleRegnumFieldsClassesAndSpan();
          changeMessagePlaceholder(e.target.value);
        }

        e.target.classList.remove('stage-error');
      });

      const subjectInput = stageFormElements[i].querySelector('[name="type"]') || false;
      if (!subjectInput) return false;

      if (subjectInput && 'gtmEventLabel' in stageFormElements[i].dataset) {
        subjectInput.addEventListener('change', function(e) {
          stageFormElements[i].dataset.gtmEventLabel = this.value;
        });
      }

      stageFormElements[i].dataset.gtmEventLabel = subjectInput.value;
    }
  }
}

export default {
  init: init
}
